import { Optional } from "#types";

/**
 * returns the enum equivalent of the input string OR undefined.
 * @param enumObj
 * @param str
 */
export const stringToEnumValue = <ET, T>(
    enumObj: ET,
    str: Optional<string>
): Optional<T> => {
    if (!str) {
        return undefined;
    }
    return Object.values(enumObj)[Object.keys(enumObj).indexOf(str)];
};
